import React from 'react'
import styles from './TilesContainer.module.scss'

export const TilesContainer: React.FC = ({children}) => {
  return <div className={styles.container}>{children}</div>;
}